import {ArrowButtonContainer} from './ArrowButton.styles'

const ArrowButton = ({direction, bgLeft, bgRight,move,handleClick}) => {
    return(
        <ArrowButtonContainer direction = {direction} bgLeft = {bgLeft} bgRight = {bgRight} move={move} onClick = {handleClick} />
    )
}

export default ArrowButton